import { sharedData } from '@/shares/dataManager';
import isAthleteManagementCallback from './isAthleteManagementCallback';

/**
 * 로그인 성공 후 Studio 전용 온보딩 리다이렉트(콜백 URL의 pathname을 `/onboarding`으로
 * 덮어쓰기)를 건너뛰어야 하는지 여부.
 *
 * b2g-athlete-management(association)는 자체 라우팅을 사용하므로 온보딩을 태우면 안 된다.
 * 두 가지 신호로 판별한다.
 * - `skipOnboarding` 쿼리 플래그: 현재 페이지 URL에서만 읽는다(sessionStorage에 저장하지
 *   않음 → 같은 탭에서 타 서비스 로그인 시 누수 방지). 메인 로그인(소셜/이메일)에서 동작.
 * - association 콜백 도메인: 콜백 URL은 sessionStorage로 유지되므로 카카오/회원가입/연동 등
 *   페이지 이동 플로우와 배포 환경 전반을 커버하는 주 판별 수단.
 */
const shouldSkipOnboarding = (callbackUrl: URL): boolean => {
  const flag = sharedData.queries.skipOnboarding;
  const hasSkipFlag = flag === 'true' || flag === '1';

  return hasSkipFlag || isAthleteManagementCallback(callbackUrl);
};

export default shouldSkipOnboarding;
